<!--首页-->
<template>
    <div class="id">
        <video :src="require('@/assets/img/footer/mpsp.mp4')" autoplay muted loop playsinline webkit-playsinline
            x5-playsinline class="videos"></video>

        <div class="swBox">
            <h2>{{ intro.title }}</h2>
            <h5 style="text-align: center;color: #cbd9da;line-height: 1.8;">
                {{ intro.content }}
            </h5>
            <div class="p1">
                <div style="text-align: center;">
                    <div style="font-size: 14px;">
                        {{ userCount }}
                    </div>
                    <div style="color:#999;font-size: 12px;padding-top: 6px;">
                        {{ $t('24小时交易量') }}
                    </div>
                </div>
                <div style="text-align: center;">
                    <div style="font-size: 14px;">
                        {{ coinCount }}
                    </div>
                    <div style="color:#999;font-size: 12px;padding-top: 6px;">
                        {{ $t('加密货币种类') }}
                    </div>
                </div>
                <div style="text-align: center;">
                    <div style="font-size: 14px;">
                        {{ moneyCount }}
                    </div>
                    <div style="color:#999;font-size: 12px;padding-top: 6px;">
                        {{ $t('注册用户数') }}
                    </div>
                </div>
            </div>
            <div class="goBtn" @click="$router.push('/mobile/trade')">
                {{ $t('去交易') }}
            </div>
        </div>
        <div class="parallax-images-wrapper">
            <div class="floating-item ball1">
                <img src="@/assets/img-pc/home_top1.png" alt="">
            </div>
            <div class="floating-item ball2">
                <img src="@/assets/img-pc/home_top2.png" alt="">
            </div>
            <div class="floating-item ball3">
                <img src="@/assets/img-pc/home_top3.png" alt="">
            </div>
            <div class="floating-item ball4">
                <img src="@/assets/img-pc/home_top4.png" alt="">
            </div>
            <div class="floating-item ball5">
                <img src="@/assets/img-pc/home_top5.png" alt="">
            </div>
            <div class="floating-item ball6">
                <img src="@/assets/img-pc/home_top6.png" alt="">
            </div>
        </div>

        <!-- 左右滚动跳转 -->
        <div class="contentBox">
            <div class="scrollContainer">
                <div class="item" v-for="(item, index) in scrollList" :key="index" @click="$router.push(`${item.url}`)">
                    <van-image width="42" height="42" :src="item.img" :radius="200" />
                    <div>{{ item.text }}</div>
                </div>
            </div>
        </div>
        <!-- 左右滚动 -->
        <van-notice-bar scrollable speed="20">
            <div style="display: flex;">
                <div v-for="item in priceData" :key="item.id" style="padding: 0 20px;">
                    {{ item.id }}
                    <span style="padding: 0 4px;">{{ item.symbol }}</span>
                    {{ item.price }}
                    <span style="padding:0 4px;" :style="{ color: item.price_zf > 0 ? '#00f0ff' : '#ff341f' }">({{
                        item.price_zf }})</span>
                </div>
            </div>

        </van-notice-bar>
        <div class="contentBox">
            <!-- 上下滚动 -->
            <div class="vanSwipe">
                <div class="vanSwipe">
                    <van-image width="20" height="20" :src="require('@/assets/img/footer/icon6.svg')" :radius="200" />
                    <van-swipe vertical :autoplay="3000" class="vertical-swipe">
                        <van-swipe-item v-for="item in notice" :key="item.id"
                            @click="$router.push(`/mobile/details?id=${item.id}`)">
                            {{ item.title }}
                        </van-swipe-item>
                    </van-swipe>
                </div>
                <van-image width="20" height="20" :src="require('@/assets/img/footer/icon7.svg')" :radius="200" />
            </div>

            <!-- AI策略交易 -->
            <div class="title">
                <van-image width="14" height="14" :src="require('@/assets/img/footer/home10.png')" />
                <div style="padding-left: 15px;"> {{ $t('AI策略交易') }}</div>
            </div>
            <div class="aiStrategy">
                <div class="strategy" v-for="item in quantAi" :key="item.id">
                    <div class="left">
                        <van-image height="30" width="30" :src="items" v-for="(items, index) in item.images"
                            :key="index" class="leftImg" />
                        <div style="padding-left: 10px;">{{ item.invest }}</div>
                    </div>
                    <!-- <van-image width="100%" class="images" src="https://shengge975.com/img/128.d318529a.png" /> -->
                    <div class="right" style="margin-top: 20px;">
                        <div style="text-align: left;  width: 40%;white-space: normal">
                            <div>{{ $t('最大收益率') }}</div>
                            <div style="padding-top: 4px;">{{ item.rate }}%</div>
                        </div>
                        <div class="imagea">
                            <van-image width="50" class="ball-gif" src="https://shengge975.com/img/2.1a27bfae.gif"
                                :radius="200" />
                            <van-image width="80" class="ball-png" :src="require('@/assets/img/footer/homeBgi2.png')"
                                :radius="200" />
                        </div>
                        <div style="text-align: right; width: 40%;white-space: normal">
                            <div>{{ $t('参与人数') }}</div>
                            <div style="padding-top: 4px;">{{ item.count }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cmBtn" @click="$router.push('/mobile/aiTrade')">
                <div style="padding-right: 20px;width: 70%;">{{ $t('了解AI量化投资') }}</div>
                <van-image width="16" height="16" :src="require('@/assets/img/footer/icon8.svg')" />
            </div>
            <!--市场行情-->
            <div class="title">
                <van-image width="18" height="18" :src="require('@/assets/img/footer/home11.png')" />
                <div style="padding-left: 15px;">{{ $t('市场行情') }}</div>
            </div>
            <!-- <div class="currency">
                <div class="text">{{ $t('数字货币') }}</div>
            </div> -->
            <div class="currencyList" v-for="item in product" :key="item.id" @click="currency(item)">
                <div class="currencyLeft">
                    <van-image width="30" :src="item.image" />
                    <div style="padding-left: 10px;">
                        <div>{{ item.symbol }}</div>
                        <!-- <div style="padding-top: 4px;">BTC / <span style="color: #999;">{{item.currency}}</span></div> -->
                        <div style="padding-top: 4px;">{{ item.title }}</div>
                    </div>
                </div>
                <div class="currencyLeft">
                    <!-- <van-image width="80" src="https://shengge975.com/img/128.d318529a.png" /> -->
                    <LineChart :chartData="item.kline" :colorS="item.price_zf > 0 ? '#00f0ff' : '#ff4834'" />
                    <div style="padding-left: 20px;text-align: right;">
                        <div>{{ item.price_zf > 0 ? '+' + item.price_zf : item.price_zf }}%</div>
                        <div style="padding-top: 4px;">${{ item.price }}</div>
                    </div>
                </div>
            </div>
            <div class="cmBtn">
                <div style="padding-right: 20px;">{{ $t('查看更多') }}</div>
                <van-image width="16" height="16" :src="require('@/assets/img/footer/icon8.svg')" />
            </div>


            <div class="title">
                <van-image width="18" height="18" :src="require('@/assets/img/footer/icon9.svg')" />
                <div style="padding-left: 15px;">{{ $t('趋势分析') }}</div>
            </div>
            <div class="homeTrend">
                <div class="leftRight">
                    <div class="strategyRight" v-for="item in product" :key="item.id" @click="currency(item)">
                        <van-image width="30" :src="item.image" />
                        <div style="padding-left: 10px;">
                            <div>{{ item.title }}</div>
                            <div style="padding-top: 4px;">{{ item.price }}</div>
                        </div>
                        <div style="padding-left: 10px;" :style="{ color: item.price_zf > 0 ? '#00f0ff' : '#ff4834' }">
                            <div>{{ item.price_zf > 0 ? '+' + item.price_zf : item.price_zf }}%</div>
                        </div>
                    </div>
                </div>
                <div style="padding-top: 30px;">
                    <div style="padding-bottom: 10px;">1min</div>
                    <van-image width="100%" :src="klineImage" />
                </div>
            </div>

            <div class="title">
                <van-image width="18" height="18" :src="require('@/assets/img/footer/icon10.svg')" />
                <div style="padding-left: 15px;">{{ $t('投资组合') }}</div>
            </div>
            <div style="color: #cbd9da;font-size: 14px;padding-bottom: 20px;">
                {{ $t('简单,安全。搜索热门投资,立即赚取收益') }}
            </div>
            <div class="invest" v-for="item in quantCombine" :key="item.id + 'a'">
                <div>
                    <div class="imageb">
                        <van-image height="28" width="28" class="vanImg" :src="itemS"
                            v-for="(itemS, index) in item.images" :key="index" />
                    </div>
                    <div style="padding-top: 20px;">{{ item.invest }}</div>
                </div>
                <div>
                    <div style="color: #00f0ff;">APR</div>
                    <div style="padding-top: 28px;">{{ item.ratemax }}%</div>
                </div>
                <div class="investLeft">
                    <div style="color: #00f0ff;">{{ $t('运行时常') }}</div>
                    <div style="padding-top: 22px;">{{ item.days }}{{ $t('日') }}</div>
                </div>
            </div>
            <div class="cmBtn" @click="$router.push('/mobile/service')">
                <div style="padding-right: 20px;">{{ $t('了解投资组合') }}</div>
                <van-image width="16" height="16" :src="require('@/assets/img/footer/icon8.svg')" />
            </div>

            <div class="bottomLink">
                <div class="item" v-for="(value, index) in bottomList" :key="index"
                    @click="$router.push(`/mobile/details?id=${value.id}`)">
                    <div>{{ value.title }}</div>
                    <van-icon name="add" color="#636368" size="22" />
                </div>
            </div>


            <!-- <div class="title">
                <van-image width="18" height="18" :src="require('@/assets/img/footer/icon11.svg')" />
                <div style="padding-left: 15px;">新闻</div>
            </div>
            <div class="news" v-for="item in 3" :key="item">
                <div class="newsName">
                    <van-image height="40" src="https://api.shengge975.com/upload/1716518693323856.png" />
                    <div class="check">
                        <div>
                            06-04-2025 03:07:48
                        </div>
                        <div class="displays" style="padding-top: 4px;">
                            <div class="displays">
                                <van-image width="22" height="22" :src="require('@/assets/img/footer/icon12.svg')" />
                                <div style="padding-left: 2px;">4629</div>
                            </div>
                            <div class="displays" style="padding-left: 10px">
                                <van-image width="24" height="24" :src="require('@/assets/img/footer/icon13.svg')" />
                                <div style="padding-left: 2px;">4629</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="newsText">
                    Dogecoin Faces Make-Or-Break Support Level – Will DOGE Hold?
                </div>
                <van-image width="100%" radius="10px" height="150"
                    src="https://www.newsbtc.com/wp-content/uploads/2025/04/Untitled-design-2025-04-05T091322.430.jpg?fit=750%2C429" />
                <div class="newsContent">
                    Dogecoin Faces Make-Or-Break Support Level – Will DOGE Hold? Sebastian Villafuerte 9 hours
                    ago 3 mins readDogecoin Faces Make-Or-Break Support Level – Will DOGE Hold? Sebastian Villafuerte 9
                    hours
                    ago 3 mins read Dogecoin Faces Make-Or-Break Support Level – Will DOGE Hold? Sebastian Villafuerte 9
                    hours
                    ago 3 mins read Dogecoin Faces Make-Or-Break Support Level – Will DOGE Hold? Sebastian Villafuerte 9
                    hours
                    ago 3 mins read
                </div>
                <div class="newsPeople">
                    <div class="newsImg">
                        <van-image height="24" class="newsImgs" :style="{ left: `-${index * 10}px` }"
                            v-for="(item, index) in 6" :key="item"
                            src="https://api.shengge975.com/upload/1716518693323856.png" />
                    </div>
                    <div class="displays">
                        <div style="color:#00f0ff;">ATOM</div>
                        <div style="color: rgb(255, 72, 52);padding: 0 6px;">-2.725%</div>
                        <div style="color:#00f0ff;">ATOM</div>
                        <div style="color: rgb(255, 72, 52);padding-left: 6px;">-2.725%</div>
                    </div>
                </div>
            </div> -->

            <!-- <div class="nft">
                <video src="@/assets/img/footer/homeMp.mp4" autoplay="autoplay" loop="loop" muted="muted"
                    class="homeMp"></video>
                <div class="nftBox">
                    <h2><span style="color: #00f0ff;">Discover </span>the Exclusive NFT Collection </h2>
                    <div class="nftBtn">
                        <div style="padding-right: 20px;">前往NFT大厅</div>
                        <van-image width="16" height="16" :src="require('@/assets/img/footer/icon8.svg')" />
                    </div>
                    <div class="nftImg">
                        <van-image width="100" class="nftImgA" src="https://shengge975.com/img/96.8c4268a0.png" />
                        <van-image width="100" class="nftImgB" src="https://shengge975.com/img/97.fb4e306f.png" />
                        <van-image width="120" src="https://shengge975.com/img/99.e8522561.png" />
                    </div>
                </div>
            </div> -->
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import { get } from '@/http/request'
import Footer from '@/common/mobile/Footer.vue'
import LineChart from '@/common/mobile/LineChart2.vue'
import { socketUrl } from "@/config.js";
import io from "socket.io-client";

export default {
    components: {
        Footer,
        LineChart
    },
    data() {
        return {
            scrollList: [{
                img: require('@/assets/img/footer/home0.png'),
                text: this.$t('提币'),
                url: '/mobile/extract'

            },
            {
                img: require('@/assets/img/footer/home1.png'),
                text: this.$t('充值'),
                url: '/mobile/topUp'
            },
            {
                img: require('@/assets/img/footer/home2.png'),
                text: this.$t('分享好友'),
                url: '/mobile/invitation'
            },
            {
                img: require('@/assets/img/footer/home3.png'),
                text: this.$t('DeFi借币'),
                url: '/mobile/borrowMoney'
            },
            // {
            //     img: require('@/assets/img/footer/home4.png'),
            //     text: '安全中心'
            // },
            {
                img: require('@/assets/img/footer/home5.png'),
                text: this.$t('投资组合'),
                url: '/mobile/service'
            },
            {
                img: require('@/assets/img/footer/home7.png'),
                text: this.$t('资产中心'),
                url: '/mobile/mine'
            },
            {
                img: require('@/assets/img/footer/home8.png'),
                text: this.$t('行情'),
                url: '/mobile/quotes'
            },

                // {
                //     img: require('@/assets/img/footer/home7.png'),
                //     text: 'NFT'
                // },
                // {
                //     img: require('@/assets/img/footer/home8.png'),
                //     text: '慈善'
                // },
                // {
                //     img: require('@/assets/img/footer/home9.png'),
                //     text: 'C2C'
                // }
            ],
            coinCount: '',
            userCount: '',
            moneyCount: '',
            intro: {},
            notice: [],
            priceData: [],
            quantAi: [],
            product: [],
            klineImage: '',
            quantCombine: [],
            bottomList: [],
            socket: null, // socket.io 实例
        };
    },
    beforeDestroy() {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
    },
    mounted() {

        this.getNoticeList()
        this.indexData()
    },
    methods: {
        startSocket() {
            this.socket = io(socketUrl, { path: '/wss', transports: ['websocket'] });
            this.socket.on('connect', () => {
                this.socket.emit("subscribe", "market");
            });
            this.socket.on("market", (msg) => {
                this.product = this.product.map(item => {
                    if (item.code === msg.code) {
                        // 用 msg 更新对应的项
                        return { ...item, price_zf: msg.price_zf, price: msg.price };
                    }
                    return item;
                });


            });
        },
        async indexData() {
            const res = await get('/index/getIndexData')
            if (res.code == 1) {
                this.coinCount = res.data.coin_count
                this.userCount = res.data.user_count
                this.moneyCount = res.data.money_count
                this.intro = res.data.intro
                this.notice = res.data.notice
                this.priceData = res.data.priceData
                this.quantAi = res.data.quantAi
                this.product = res.data.product
                this.klineImage = res.data.kline_image
                this.quantCombine = res.data.quantCombine
                this.startSocket()
                return
            }
        },
        currency(item) {
            console.log(item);
            this.$router.push(`/mobile/trade?code=${item.symbol}`)
        },

        async getNoticeList() {
            const res = await get('/richtext/getNoticeList', { limit: 999 })
            if (res.code == 1) {
                this.bottomList = res.data
                return
            }
        },

    },
    beforeUnmount() { },
};
</script>
<style lang="less" scoped>
.id {
    color: #fff;
    padding-bottom: 60px;
    padding-top: 50px;
    font-size: 14px;

    .parallax-images-wrapper {
        position: absolute;
        inset: 0;
        pointer-events: none;
        z-index: 0;

        .floating-item {
            position: absolute;
        }

        /* 定义动画 */
        @keyframes myfirst {
            0% {
                transform: translateY(0px);
            }

            50% {
                transform: translateY(20px);
                /* 向下移动 */
            }

            100% {
                transform: translateY(0px);
                /* 回到原位 */
            }
        }

        @keyframes myfirstS {
            0% {
                transform: translateY(0px);
            }

            50% {
                transform: translateY(-20px);
                /* 向下移动 */
            }

            100% {
                transform: translateY(0px);
                /* 回到原位 */
            }
        }

        .ball1 {
            left: 20%;
            top: 10%;
            animation: myfirstS 2s infinite;

            img {
                width: 30px;
                height: 30px;
            }
        }

        .ball2 {
            left: 10%;
            top: 22%;
            animation: myfirst 2s infinite;

            img {
                width: 60px;
                height: 60px;
            }
        }

        .ball3 {
            left: 20%;
            top: 46%;
            animation: myfirstS 2s infinite;

            img {
                width: 40px;
                height: 40px;
            }
        }

        .ball4 {
            right: 20%;
            top: 10%;
            animation: myfirst 2s infinite;

            img {
                width: 30px;
                height: 30px;
            }
        }

        .ball5 {
            right: 10%;
            top: 25%;
            animation: myfirstS 2s infinite;

            img {
                width: 60px;
                height: 60px;
            }
        }

        .ball6 {
            right: 20%;
            top: 43%;
            animation: myfirst 2s infinite;

            img {
                width: 40px;
                height: 40px;
            }
        }
    }

    .displays {
        display: flex;
        align-items: center;
    }

    .van-notice-bar {
        padding: 0;
        background-color: #0f0f16;
        border-top: 1px solid #2b2b3c;
        border-bottom: 1px solid #2b2b3c;
        color: #fff;
        font-size: 16px;
        height: 50px;
    }

    .videos {
        width: 100%;
        height: 500px;
        object-fit: cover;
        display: block;
    }


    .swBox {
        width: 90%;
        position: absolute;
        top: 150px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 100;
        display: flex;
        flex-direction: column;
        align-items: center;

        .p1 {
            display: flex;
            width: 100%;
            padding: 20px 30px;
            margin-top: 80px;
            justify-content: space-between;
            border: 1px solid hsla(0, 0%, 100%, .3);
            background: rgba(0, 0, 0, .5);
            border-radius: 50px;
        }

        .goBtn {
            background: #00f0ff;
            color: #000;
            padding: 10px;
            width: 100%;
            font-size: 16px;
            text-align: center;
            border-radius: 50px;
            margin-top: 60px;
        }

    }

    .contentBox {
        padding: 15px;

        .nft {
            position: relative;

            .homeMp {
                width: 100%;
                height: 360px;
                object-fit: cover;
                border-radius: 30px;
                margin-bottom: 20px;
            }

            .nftBox {
                position: absolute;
                top: 0px;
                left: 0;
                z-index: 100;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 0 20px;

                .nftBtn {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #fff;
                    background: rgba(0, 0, 0, .5);
                    color: #fff;
                    border-radius: 40px;
                    overflow: hidden;
                    padding: 10px 80px;
                    margin: 30px 0;
                }

                .nftImg {
                    display: flex;
                    align-items: center;
                    position: relative;
                    left: -20px;
                    top: 40px;

                    .nftImgA {
                        position: relative;
                        top: 0;
                        left: 0px;
                        z-index: 1;
                    }

                    .nftImgB {
                        position: relative;
                        top: 40px;
                        left: -40px;
                    }


                }

            }
        }

        .news {
            background-color: #0d0e0f;
            border-radius: 20px;
            padding: 15px;
            font-size: 14px;
            margin-bottom: 30px;

            .newsName {
                display: flex;
                align-items: center;

                .check {
                    padding-left: 15px;
                }
            }

            .newsText {
                padding: 10px 0;
            }

            .newsContent {
                margin-bottom: 15px;
                padding-top: 10px;
                position: relative;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
            }

            .newsPeople {
                display: flex;
                align-items: center;
                border-radius: 40px;
                border: 1px solid #1a1b24;
                background: #000;
                padding: 5px 10px;
                justify-content: space-between;
                font-size: 11px;
            }

            .newsImg {
                display: flex;
                align-items: center;
                position: relative;

                .newsImgs {
                    position: relative;
                    top: 0;

                }

            }

        }

        .invest {
            background-color: #0d0e0f;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;
            font-size: 14px;
            margin-bottom: 15px;

            .investLeft {
                text-align: right;
            }

            .imageb {
                display: flex;
                align-items: center;
                position: relative;

                .vanImg:nth-child(2) {
                    position: relative;
                    top: 0;
                    left: -15px;
                }

                .vanImg:nth-child(3) {
                    position: relative;
                    top: 0;
                    left: -15px;
                }
            }

        }

        .homeTrend {
            background-color: #0d0e0f;
            border-radius: 20px;
            padding: 20px;
            padding-bottom: 0px;
            font-size: 14px;
            margin-bottom: 10px;

            .leftRight {
                display: flex;
                overflow-x: auto;
                white-space: nowrap;
                scrollbar-width: none;

                .strategyRight {
                    display: flex;
                    margin-right: 50px;
                    display: flex;
                    align-items: flex-end;
                }

                .strategyRight:last-child {
                    margin-right: 0px;
                }

            }
        }

        .currencyList {
            background-color: #0d0e0f;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 15px;
            font-size: 14px;
            margin-bottom: 20px;

            .currencyLeft {
                display: flex;
                align-items: center;
            }

        }

        .currency {
            border: 1px solid #333;
            background-color: #000;
            color: #fff;
            border-radius: 80px;
            overflow: hidden;
            padding: 5px 0;
            margin-bottom: 24px;

            .text {
                display: inline-block;
                background: linear-gradient(90deg, #00e3ff, #089);
                padding: 8px 36px;
                margin-left: 5px;
                border-radius: 40px;
                font-size: 13px;
            }
        }

        .cmBtn {
            margin: 20px auto;
            width: 70vw;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #333;
            background-color: #000;
            color: #fff;
            border-radius: 40px;
            overflow: hidden;
            padding: 10px 0;
        }

        .bottomLink {
            .item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #3e424f;
                padding: 15px 0;
                font-size: 16px;
            }
        }

        .aiStrategy {
            display: flex;
            overflow-x: auto;
            white-space: nowrap;
            -ms-overflow-style: none;
            scrollbar-width: none;

            .strategy {
                width: 80vw;
                flex-shrink: 0;
                display: flex;
                flex-direction: column;
                margin-right: 24px;
                padding: 20px 0;
                background-image: url('~@/assets/img/footer/homeBgi0.png');
                background-repeat: no-repeat;
                background-size: 100% 100%;

                .left {
                    padding: 0 10px;
                    display: flex;
                    align-items: center;
                    position: relative;


                    .leftImg:nth-child(2) {
                        position: relative;
                        top: 0;
                        left: -20px;
                    }
                }

                .images {
                    padding: 10px 0;
                }

                .right {
                    width: 75vw;
                    padding: 0 15px;
                    display: flex;
                    align-items: center;
                    background-image: url('~@/assets/img/footer/homeBgi1.png');
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    margin: 0 auto;
                    justify-content: space-between;
                    font-size: 12px;

                    .imagea {
                        width: 50px;
                        height: 55px;
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .ball-gif {
                            position: absolute;
                            top: 3px;
                            left: 0;
                            z-index: 2;
                        }

                        .ball-png {
                            position: absolute;
                            z-index: 1;
                            top: -12px;
                            left: -15px;
                        }
                    }
                }
            }

            .strategy:last-child {
                padding-right: 0px;
            }

        }

        .title {
            display: flex;
            align-items: center;
            font-size: 20px;
            padding: 20px 0;
        }

        .vanSwipe {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .vertical-swipe {
                height: 40px;
                line-height: 40px;
                color: #fff;
                padding-left: 10px;
            }
        }


        ::v-deep .van-swipe__indicators {
            display: none;
        }

        .scrollContainer {
            display: flex;
            overflow-x: auto;
            white-space: nowrap;
            -ms-overflow-style: none;
            scrollbar-width: none;


            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center;
                padding-right: 30px;
                font-size: 14px;
            }

            .item:last-child {
                padding-right: 0px;
            }
        }
    }
}
</style>
